import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { CloudUpload } from '@mui/icons-material';
import { Chip, InputLabel } from '@mui/material';

import type { ICloudUploadStyledProps } from './uploadFiles.type';

export const UploadFilesStyled = styled('div')`
  width: 100%;
`;
UploadFilesStyled.displayName = 'UploadFilesStyled';

export const DropzoneStyled = styled('div', {
  shouldForwardProp: (prop) => !['minHeight', 'error'].includes(prop),
})<{
  error: boolean;
  minHeight?: number | undefined;
}>`
  ${({ theme }) => css`
    background-color: ${theme.palette.grey[200]};
    border-radius: ${theme.shape.borderRadius}px;
  `}

  ${({ theme, error }) =>
    error &&
    css`
      border: 1px solid ${theme.palette.error.main};
    `}

  width: 100%;
  min-height: ${({ minHeight }) => minHeight ?? 104}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: ${({ minHeight }) => minHeight ?? 160}px;
  }
`;
DropzoneStyled.displayName = 'DropzoneStyled';

export const CloudUploadStyled = styled(CloudUpload, {
  shouldForwardProp: (prop) => !['size'].includes(prop),
})<ICloudUploadStyledProps>`
  ${({ size }) =>
    size === 'small'
      ? css`
          width: 2rem;
          height: 2rem;
        `
      : css`
          width: 4rem;
          height: 4rem;
        `};

  fill: ${({ theme }) => theme.palette.divider};

  ${({ theme }) => theme.breakpoints.up('md')} {
    ${({ size }) =>
      size === 'small'
        ? css`
            width: 6rem;
            height: 6rem;
          `
        : css`
            width: 8rem;
            height: 8rem;
          `};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      filter: grayscale(100%);
    `}
`;
CloudUploadStyled.displayName = 'CloudUploadBlackStyled';

export const LabelStyled = styled(InputLabel)<{ disabled: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.text.disabled : theme.palette.text.secondary};
  text-align: center;
  word-wrap: break-word;
  white-space: pre-wrap;
`;
LabelStyled.displayName = 'LabelStyled';

export const DropzoneLabelAreaStyled = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
DropzoneLabelAreaStyled.displayName = 'DropzoneLabelAreaStyled';

export const ChipStyled = styled(Chip)`
  width: 100%;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 272px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: 304px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 400px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 504px;
  }
`;
ChipStyled.displayName = 'ChipStyled';
